// src/shared/components/Badges.jsx
import React from 'react';
import Icon from './Icon';
import { PRIORITIES, STATUS_META, TICKET_STATUS } from '../constants';
import { getInitials, getStringHue } from '../utils/userPresentation';
import { REQUEST_TYPES } from '../../data';
import '../../styles/components/badges.css';

export function Avatar({ agent, size = 28 }) {
  if (!agent) {
    return (
      <div className="avatar avatar--empty" style={{
        width: size, height: size,
        fontSize: size * 0.4,
      }}>?</div>
    );
  }
  
  const displayName = agent.name || agent.full_name || agent.user_name || agent.email || agent.id || '?';
  const initials = agent.initials || getInitials(displayName);
  const hue = Number.isFinite(Number(agent.hue)) && agent.hue !== null && agent.hue !== ''
    ? Number(agent.hue)
    : getStringHue(displayName);

  return (
    <div className="avatar avatar--filled" style={{
      width: size, height: size,
      background: `linear-gradient(135deg, hsl(${hue} 70% 60%), hsl(${hue} 70% 45%))`,
      fontSize: size * 0.42,
    }}>{initials}</div>
  );
}

export function StatusBadge({ status }) {
  const s = STATUS_META[status] || STATUS_META[TICKET_STATUS.NEW];
  return (
    <span className={`badge badge-${s.tone}`}>
      <Icon name={s.icon} size={11} stroke={2} />{s.label}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const p = PRIORITIES[priority] || { label: 'Unclassified' };
  if (priority === 'urgent') return <span className="prio prio-urgent"><Icon name="flame" size={11} stroke={2} />{p.label}</span>;
  if (priority === 'high')   return <span className="prio prio-high"><Icon name="arrow-up" size={11} stroke={2.2} />{p.label}</span>;
  if (priority === 'low')    return <span className="prio prio-low"><Icon name="arrow-down" size={11} stroke={2.2} />{p.label}</span>;
  return <span className="prio prio-medium">{p.label}</span>;
}

// Small colored-square icon badge used to represent a category everywhere
// (request table, filters, PIC mapping, category admin list) — keep this the
// one place that owns the look, so every surface stays visually in sync.
export function CategoryIcon({ icon, color, size = 20, className }) {
  return (
    <span className={`category-icon ${className || ''}`} style={{
      width: size, height: size,
      background: `color-mix(in oklab, ${color || '#9ca3af'} 15%, transparent)`,
      color: color || '#9ca3af',
    }}>
      <Icon name={icon || 'tag'} size={Math.round(size * 0.6)} stroke={2} />
    </span>
  );
}

export function TypeChip({ type, typeMeta }) {
  const t = REQUEST_TYPES.find(t => t.id === type)
    || (typeMeta ? { id: type, ...typeMeta } : null)
    || { id: type, label: type || 'Unknown', icon: 'more', color: '#9ca3af' };
  return (
    <span className="type-chip">
      <CategoryIcon icon={t.icon} color={t.color} />
      <span className="type-chip__label">{t.label}</span>
    </span>
  );
}
